/*
 * @Description:入口文件
 * @Author: rqcheng
 * @Date: 2023-03-30 14:14:52
 * @LastEditTime: 2025-06-05 16:16:26
 * @LastEditors: rqcheng
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import { msgNotify } from "./common/js/notify";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import "./common/css/index.less";
import L from "leaflet"; //引入问题
import "leaflet/dist/leaflet.css";
import "./plugins";

// this part resolve an issue where the markers would not appear
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

Vue.config.productionTip = false;
Vue.use(ElementUI, { size: "small" });

Vue.prototype.$axios = axios;

Vue.prototype._msgNotify = msgNotify;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  mounted() {
    this.redirectUrl();
  },
  methods: {
    redirectUrl() {
      // 路由跳转
      router.beforeEach((to, from, next) => {
        window.scrollTo(0, 0); //滚动条置顶
        next();
      });
    }
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js